<template>
<!-- http://localhost:8080/?UI=00b400&PORT=1000&SIP=1.1.1.1&MA=AA0A0A0A0A0A -->
      <div class="rm" :ref="'rm_'+index">
        <!-- last name and room number -->
        <div class="rm-form p-15">
          <div v-if="registration_method.registration_method_id==2">
            <div class="row mb-15 header-text">
              <span class="custom-orng">Guests of the Hotel Magdalena</span>, please provide the<br> following information for access to our Wi-Fi Network.
            </div>
            <div class="row mb-15">
              <input v-model="form.last_name" id="last_name" class="input-text rounded ln" type="text" placeholder="Last Name" />
              <input v-model="form.room_number" id="room_number" class="input-text rounded rn" type="text" placeholder="Room #" />
              <button  @click="emitRegistrationMethodData()" class="btn rounded submit-ln-rn" type="button">Proceed</button>
            </div>
          </div>

          <!-- email address -->
          <div v-if="registration_method.registration_method_id==3" class="row mb-15 p-rel split-grid">
            <div class="header-text mb-15 grid-col-1" style="text-align: left;">
              <span class="custom-grn">Day visitors</span>, please provide your email address here for Wi-Fi access.
            </div>
            <div class="grid-col-2">
              <input v-model="form.email_address" class="input-text rounded mb-15" type="text" placeholder="Email" />
              <div class="mb-15" style="text-align: left">
                <button @click="emitRegistrationMethodData()" class="btn rounded btn-grn" type="button" >Proceed</button>
              </div>
            </div>
          </div>

          <!-- access code -->
          <div v-if="registration_method.registration_method_id==4" class="row mb-15 p-rel split-grid">
            <div class="header-text mb-15 grid-col-1">
              <span class="custom-grn">Event Guests</span>, please enter your unique event code here for Wi-Fi access.
            </div>
            <div class="grid-col-2">
              <input v-model="access_code" class="input-text rounded mb-15" type="text" placeholder="Event Code" />
              <span v-if="!access_code_valid" class="error-text">{{access_code_error_text}}</span>
              <div class="mb-15">
                <button @click="emitRegistrationMethodData()" class="btn rounded btn-grn" type="button">Proceed</button>
              </div>
            </div>
          </div>

          <p class="text-center text-14 mb-0">By clicking proceed you agree to the
            <span @click="selectTermsOfService(index)" class="text-link">Terms and Conditions</span>
          </p>
          <div class="terms-of-service text-left pt-20" v-if="selected_tos==index">
            <div v-html="registration_method.terms_of_service"></div>
            <div class="mt-30 text-center"><button class="btn-close" @click="selectTermsOfService(null)">CLOSE</button></div>
          </div>
        </div>
      </div> <!-- rm -->
</template>
<script>
export default {
  name: 'registration_method',
  props: ['index','selected','selected_tos','color_background_button','color_text_button','registration_method'],
  data(){
    return{
      access_code: null,
      access_code_valid: true,
      access_code_error_text: 'Required',
      form: {
        last_name: '',
        room_number: '',
        email_address: '',
      },
    }
  },
  watch: {
  
  },
  mounted(){
    
  },
  methods: {
    // Generate the description that appears below the Registration Method name
    generateDescription:function(rm){
      if(rm.type!='rateplan') return null;
      var description = '';
      if (parseInt(rm.price)==0) {
        description += 'Connect';
      } else {
        description += '$' + rm.price;
      }

      if(rm.duration>=24){
        description += ' for ' + rm.duration / 24 + ' day'
        if(rm.duration / 24 > 1){
          description += 's';
        }
      } else {
        description += ' for ' + rm.duration + ' hour'
        if(rm.duration > 1){
          description += 's';
        }
      }

      description += ' with ';
      if(rm.additional_devices>0){
        description += 'up to ' + rm.additional_devices + ' devices';
      } else {
        description += '1 device';
      }
      if(rm.speed_upload && rm.speed_download){
        description += ' (' + rm.speed_upload + ' Up / ' + rm.speed_download + ' Down)';
      }
      return description;
    },
    // Send selected Registration Method back to parent
    selectRegistrationMethod:function(index){
      this.$emit('changeSelected', index);
    },
    // Send selected Terms of Service back to parent
    selectTermsOfService:function(index){
      this.$emit('changeSelectedTOS', index);
    },
    // Manipulate and send registration method data back to parent
    emitRegistrationMethodData:function(){
      // If no access code set, show required text
      if(this.registration_method.type=='accesscode' && !this.access_code){
        this.access_code_valid = false;
        return;
      }
      var emitted = {
        registration_method_id: this.registration_method.registration_method_id,
        rateplan_id: null,
        email_address: null,
        last_name: null,
        room_number: null,
        access_code: null,
      };
      if(this.registration_method.registration_method_id=='1'){
        emitted.rateplan_id = this.registration_method.id;
      } else if(this.registration_method.registration_method_id=='2'){
        emitted.rateplan_id = this.registration_method.id;
        emitted.last_name = this.form.last_name;
        emitted.room_number = this.form.room_number;
      } else if(this.registration_method.registration_method_id=='3'){
        emitted.rateplan_id = this.registration_method.id;
        emitted.email_address = this.form.email_address;
      } else if(this.registration_method.registration_method_id=='4'){
        emitted.access_code = this.access_code;
      }
      this.$emit('emitRegistrationMethodData', emitted);
    },

  }
}
</script>
<style>
@font-face { 
  font-family: "Grota Sans Rounded";
  src: url(./assets/fonts/grotasansrounded-regular-webfont.otf); 
}
@font-face { 
  font-family: "Halis Rounded";
  src: url(./assets/fonts/halis/HalisR-Regular.otf); 
}



.rm {background: rgba(255,255,255,.67); margin-bottom: 10px; font-family: "Halis Rounded";}
.rm a, .rm span.text-link { color: #000000; text-decoration: underline; cursor: pointer }
.rm .help-text { color: #000000; padding: 5px 0; font-size: 14px; font-style: italic; text-align: center; display: block; }
.rm .error-text { text-transform: uppercase; position: absolute; line-height: 1; right: 12px; top: 12px; padding: 8px 8px 7px 8px; background: red; color: #ffffff; border-radius: 3px; text-align: left; font-weight: bold; font-size: 12px; }
.rm .rm-header { background: #ffffff; border-top-width: 1px; border-top-style: solid; cursor: pointer; }
.rm .rm-form { margin: auto; width: 80%; border-top-width: 1px; border-top-style: solid; background: transparent;}
.rm:last-child { border-bottom-width: 1px; border-bottom-style: solid; }
.rm .input-text { border: 1px solid #cccccc; color: #000000; overflow: visible;width: 100%;padding: 15px; font-size: 16px; height:40px;}
.rm .input-text.rounded { border-radius: 6px; }
.rm .input-text.ln{ width: 35%; display: inline;}
.rm .input-text.rn{ width: 20%; display: inline;}
.rm .btn { background: #CB6015; color: #fff; width: 180px; height: 40px; font-size: 14px; font-weight: bold; padding: 0;}
.rm .btn { cursor: pointer;}
.rm .btn.rounded { border-radius: 4px; }
.rm label { display: inline-block; padding: 10px 30px 10px 0px; width: 100%; font-size: 18px; }
.rm label span { font-size: 16px; font-weight: normal; }
.rm .input-radio { display: inline-block; padding: 10px; }

.split-grid{
  padding-top: 30px;
}
.grid-col-1{
  width: 45%;
  float: left;
  text-align: left;
}
.grid-col-2{
  width: 45%;
  float: right;
}
.split-grid:after{
  content: "";
  display: table;
  clear: both;
}
.grid-col-2{
  text-align: left;
}
.custom-grn{
  font-weight: bold;
  color: #76881D;
}
.custom-orng{
  font-weight: bold;
  color: #CB6015;
}
.btn-grn{
  background: #76881D !important;
}
.header-text{
  font-size: 22px;
}
.header-text{
  
}
#last_name{
  margin-right: 5%;
}
#room_number{
  margin-right: 5%;
}
.p-15{
  padding: 15px;
}
@media only screen and (max-width: 600px) {
  .header-text{
    font-size: 16px;
    text-align: left;
  }
  .split-grid{
    display: inline;
  }
  .split-grid:after{
    display: inline;
  }
  .grid-col-1{
    float: none;
    width: 100%;
  }
  .grid-col-2{
    float: none;
    width: 100%;
  }
  .rm .input-text.rn, .rm .input-text.ln{ 
    width: 100%; 
    display: block;
    margin-bottom: 15px;
  }

}
</style>
